
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-terms-of-use/archive",
      function () {
        return require("private-next-pages/api-terms-of-use/archive.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-terms-of-use/archive"])
      });
    }
  